import React, { useState, useEffect } from 'react';
import './CheckboxList.scss';
import {
    Grid,
    FormControlLabel,
    Checkbox,
} from '@mui/material';

/**
 * @param {import('./typing').CheckboxListProps} props
 * @returns
 */
export default function CheckboxList(props) {
    const { items, onChange, useNumericTotals } = props;

    const [selection, setSelection] = useState(items);

    useEffect(() => {
        setSelection(items);
    }, [JSON.stringify(items)]);

    /**
     * @param {number} index
     * @param {boolean} checked
     */
    const handleChange = (index, checked) => {
        const newSelection = [...selection];
        newSelection[index].checked = checked;
        setSelection(newSelection);
        if (onChange && typeof onChange === 'function') {
            onChange(newSelection, newSelection[index]);
        }
    };

    /**
     * @param {number} index
     */
    const generateItem = (index) => (
        <React.Fragment
            key={`${selection[index].name}_${selection[index].id}_${index}`}
        >
            <Grid
                item
                xs={10}
                className="SelectionCheckbox"
            >
                <FormControlLabel
                    control={(
                        <Checkbox
                            color="primary"
                            checked={selection[index].checked}
                            onChange={(event) => { handleChange(index, event.target.checked); }}
                            name={selection[index].name}
                        />
                    )}
                    label={selection[index].name}
                />
            </Grid>
            <Grid
                item
                xs={1}
                className="SelectionNumber"
            >
                <div className="NumberCentered">
                    {
                        useNumericTotals
                            ? selection[index].total
                            : null
                    }
                </div>
            </Grid>
        </React.Fragment>
    );

    const generateItems = () => {
        const itemList = [];
        for (let i = 0; i < selection.length; i++) {
            itemList.push(generateItem(i));
        }
        return itemList;
    };

    return (
        <Grid
            container
            justifyContent="space-between"
        >
            {
                generateItems()
            }
        </Grid>
    );
}